import { ResizableImage } from 'mui-tiptap';
import { mergeAttributes } from '@tiptap/core';

export const ResizableImageWithAlign = ResizableImage.extend({
  parseHTML() {
    return [
      {
        tag: 'img[src]',
        getAttrs: (node) => {
          if (!(node instanceof Element)) {
            return false;
          }
          const src = node.getAttribute('src');
          return this.options.isAllowedImgSrc(src) && null;
        },
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const imgElement = [
      'img',
      mergeAttributes(
        { height: 'auto' },
        this.options.HTMLAttributes,
        HTMLAttributes
      ),
    ] as const;

    const divStyle = node.attrs.textAlign
      ? `text-align: ${node.attrs.textAlign}`
      : undefined;

    return ['div', { style: divStyle }, imgElement];
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      textAlign: {
        default: null,
        renderHTML: () => ({}),
        parseHTML: (element) => {
          const parent = element.parentElement;
          if (parent?.tagName === 'DIV' && parent.style.textAlign) {
            return parent.style.textAlign;
          }
          return null;
        },
      },
    };
  },
});
